import React from 'react';
import { Link } from 'react-router-dom';

export default function Processing({ tx, onNew }) {
  if (!tx) return (
    <div className="p-6 bg-yellow-50 rounded-lg">
      <p>Transaction en cours...</p>
      <div className="mt-4">
        <button onClick={onNew} className="py-2 px-4 rounded bg-blue-600 text-white">Nouvelle transaction</button>
      </div>
    </div>
  );

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Transaction en cours</h3>
      <div className="p-4 bg-gray-50 rounded-lg border">
        <p>Référence: <strong>{tx.paymentRef || tx.id}</strong></p>
        <p>Montant: <strong>{tx.amount} {tx.currency}</strong></p>
        <p>Statut: <strong>{tx.status}</strong></p>
        <p>Message: Merci de votre patience. Suivez le statut sur votre tableau de bord.</p>
      </div>

      <div className="flex gap-3">
        <Link to="/transactions" className="flex-1 py-3 rounded-lg bg-gray-100 text-center">Historique</Link>
        <button onClick={onNew} className="flex-1 py-3 rounded-lg bg-gradient-to-r from-green-600 to-green-500 text-white">Nouvelle transaction</button>
      </div>
    </div>
  );
}
